import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { GuidedHouseholdReviewSections } from 'Components/UI/guidedHouseholdReview/sections';
import { FDAlert } from '@facet-wealth/design';
import { metaOverrideSet } from './metaOverrideSet';

export const GuidedHouseholdReviewOwnVsOweLayout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <>
      {resource.attr('missingData').resources()?.length() > 0 && (
        <FDAlert
          status="warning"
          title={resource.metaField('missingData').attr('prompt')}
          details={resource.attr('missingData').resources().list().map(v => v.attr('label'))}
        />
      )}
      <GuidedHouseholdReviewSections metaOverrideSet={metaOverrideSet} collection={resource.attr('sections')} />
    </>
  );
};
